module.exports = __webpack_public_path__ + "static/HOLOPORTATION_video-864451c65dc3021c648c49d96ae6343d.png";